<template>
    <div>
        <CButton            
            color="info"
            class="m-2"            
            @click="syncCreateGroup"
        >
            Create Group            
        </CButton>
        <CCard v-if="openCreateGroup" bodyWrapper class="card_background">
            <CRow>
                <CCol sm="4">
                    <CInput
                        label="Group name"
                        :value="group_name"
                        :value.sync="group_name"
                    />
                </CCol>
                <CCol sm="4">
                    <label>Subscription ID</label>
                    <multiselect 
                        v-model="sub_ids" 
                        :options="idOptions" 
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"                        
                        group-values="ids" 
                        group-label="all" 
                        :group-select="true" 
                        placeholder="Type to search" 
                        track-by="label" 
                        label="label">
                        <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} IDs selected</span></template>
                        <template slot="tag">{{ '' }}</template>
                    </multiselect>
                </CCol>
                <CCol sm="4">
                    <label style="display: block">{{ $t('Language') }}</label>
                    <CSelect
                        :value.sync = "lang"
                        :options = "lang_list"
                        
                    >
                  </CSelect>
                </CCol>               
                
            </CRow>
            <CRow style="padding-top: 20px;">
                <CCol sm="2">
                    <label style="display: block">Header</label>
                    <input type="color" v-model="header_color" style="border: None" />
                </CCol>
                <CCol sm="2">
                    <label style="display: block">Header text</label>
                    <input type="color" v-model="header_txt_color" style="border: None" />
                </CCol>
                <CCol sm="2">
                    <label style="display: block">Subheader</label>
                    <input type="color" v-model="sub_header_color" style="border: None" />
                </CCol>
                <CCol sm="2">
                    <label style="display: block">Subheader text</label>
                    <input type="color" v-model="sub_header_txt_color" style="border: None" />
                </CCol>
                <CCol sm="2">
                    <label style="display: block">Sidebar</label>
                    <input type="color" v-model="sidebar_color" style="border: None" />
                </CCol>
               
               <!--  <CCol sm="2">
                    <label style="display: block">Sidebar Hover</label>
                    <input type="color" v-model="sidebar_hover_color" style="border: None" />
                </CCol> -->
                <CCol sm="2">
                    <label style="display: block">Minimizer</label>
                    <input type="color" v-model="sidebar_mini_color" style="border: None" />
                </CCol>
                <!-- <CCol sm="2">
                    <label style="display: block">Minimizer Hover</label>
                    <input type="color" v-model="sidebar_mini_hover_color" style="border: None" />
                </CCol> -->
                
            </CRow>
            <CRow style="padding-top: 20px;">
                 <CCol sm="2">
                    <label style="display: block">Sidebar text</label>
                    <CSelect
                        :value.sync = "sidebar_txt_color"
                        :options = "color_options"
                        
                    >
                  </CSelect>
                </CCol>
                <CCol sm="2">
                    <label style="display: block">Membership URL</label>
                    <!-- <CSelect
                        :value.sync = "membership_url"
                        :options = "membership_url_options"
                    >
                    </CSelect> -->
                    <CInput type="text" v-model="membership_url" style="border: None" />
                </CCol>
                <CCol sm="4">
                    <label style="display: block">Tutorial URL</label>
                    <CInput type="text" v-model="tutorial_url" style="border: None" />
                </CCol>
                <CCol sm="4">
                    <div style="height: 30px; padding-left: 7px;">
                        <CInputCheckbox class="check-box"
                            :checked.sync = "instagram.check"
                        ><template #label>
                            Instagram
                        </template></CInputCheckbox>
                    </div>
                    <CInput type="text" v-model="instagram.url" style="border: None" />
                </CCol>

                
            </CRow>
            <CRow style="padding-top: 20px;">
                
                
                <CCol sm="4">
                    <div style="height: 30px; padding-left: 7px;">
                        <CInputCheckbox class="check-box"
                            :checked.sync = "facebook.check"
                        ><template #label>
                            facebook
                        </template></CInputCheckbox>
                    </div>
                    <CInput type="text" v-model="facebook.url" style="border: None" />
                </CCol>
                <CCol sm="4">
                    <div style="height: 30px; padding-left: 7px;">
                        <CInputCheckbox class="check-box"
                            :checked.sync = "whatsapp.check"
                        ><template #label>
                            whatsapp
                        </template></CInputCheckbox>
                    </div>
                    <CInput type="text" v-model="whatsapp.url" style="border: None" />
                </CCol>
                <CCol sm="4">
                    <div style="height: 30px; padding-left: 7px;">
                        <CInputCheckbox class="check-box"
                            :checked.sync = "youtube.check"
                        ><template #label>
                            youtube
                        </template></CInputCheckbox>
                    </div>
                    <CInput type="text" v-model="youtube.url" style="border: None" />
                </CCol>
                
            </CRow>
            <CRow style="padding-top: 20px;">
                
                
                <CCol sm="4">
                    <div style="height: 30px; padding-left: 7px;">
                        <CInputCheckbox class="check-box"
                            :checked.sync = "telegram.check"
                        ><template #label>
                            telegram
                        </template></CInputCheckbox>
                    </div>
                    <CInput type="text" v-model="telegram.url" style="border: None" />
                </CCol>
                <CCol sm="4">
                    <div style="height: 30px; padding-left: 7px;">
                        <CInputCheckbox class="check-box"
                            :checked.sync = "feed_alert"
                        ><template #label>
                            alert on feed page <span v-if="feed_alert">( currently shown )</span><span v-else>( currently hidden )</span>
                        </template></CInputCheckbox>
                    </div>                   
                </CCol>
                <CCol sm="4">
                    <label class="select_avatar_label">Logo</label>
                    <div class="">
                        <sub_logo_upload
                            :boundary="{
                                width: 640,
                                height: 230
                            }"
                            :viewport="{
                                width: 640,
                                height: 230
                            }"
                            :resize="false"
                            :defaultAvatarSrc="logoUrl"
                            :zoom="true"
                            @cropped="cropped"
                        />
                    </div>
                </CCol>
            </CRow>
            <div class="d-flex justify-content-end action-btns">
                
                <CButton
                    v-if="group_id == null"
                    
                    color="info"
                    class="m-2"
                    :disabled="!canPost"
                    @click="saveLogo"
                >
                    Save
                    <CSpinner v-if="loading" color="danger" size="sm" />
                </CButton>
                <CButton
                    v-else
                    
                    color="info"
                    class="m-2"
                    :disabled="!canPost"
                    @click="updateLogo"
                >
                    Update
                    <CSpinner v-if="loading" color="danger" size="sm" />
                </CButton>

                <CButton
                    color="info"
                    class="m-2"
                    @click="cancel"
                >
                    Cancel
                </CButton>
            </div>
        </CCard>

        <CCard bodyWrapper class="card_background">
            <CDataTable
                :key="update_key"
                :loading="table_loading"                  
                :items="sub_items"
                :fields="sub_fields"                  
                :sorter="showSorter"                  
            >
            <template #logo_url="{item, index}">
                <td >
                    <img :key="update_key" :src="item.logo_url" style="width: 100px;" />
                </td>
            </template>
            <template #action="{item, index}">
                <td >
                    <CButton
                        shape="pill"
                        size="sm"
                        :color="'success'"
                        class="mx-1 detail_button2"
                        @click="editGroup(item._id)"
                    >
                        Edit
                    </CButton>
                    <CButton
                        shape="pill"
                        size="sm"
                        :color="'success'"
                        class="mx-1 detail_button2"
                        @click="deleteGroup(item._id)"
                    >
                        Delete
                    </CButton>
                    <CButton
                        shape="pill"
                        size="sm"
                        :color="'success'"
                        class="mx-1 detail_button2"
                        @click="copyGroup(item._id)"
                    >
                        Copy
                    </CButton>
                </td>
            </template>
            </CDataTable>
        </CCard>

    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import { VUE_APP_URL } from "@/config";
    import sub_logo_upload from "@/components/sub_logo_upload";
    import moment from 'moment';
    import Multiselect from 'vue-multiselect';
    import { CFormCheck } from '@coreui/vue';
    import swal from 'sweetalert2';

    import {displaySuccess, displayError} from '../helpers/message';
    import {convertUTCToLocal, defaultFormat} from '@/helpers/time';

    export default {
        name: 'PostTip',
        components: {
            sub_logo_upload,
            Multiselect,
            CFormCheck
        },
        data () {
            return {
                membership_url_options: [
                    { label: "sospesosoftwares.com", value: "https://sospesosoftwares.com/#pricing"},
                    { label: "goaltraders.com.br", value: "https://goaltraders.com.br/#pricing"}                    
                ],
                membership_url: "https://sospesosoftwares.com/#pricing",
                tutorial_url: "",
                instagram: {
                    check: false,
                    url: ""
                },
                facebook: {
                    check: false,
                    url: ""
                },
                whatsapp: {
                    check: false,
                    url: ""
                },
                youtube: {
                    check: false,
                    url: ""
                },
                telegram: {
                    check: false,
                    url: ""
                },
                feed_alert: true,
                openCreateGroup: false,
                sub_ids: [],
                idOptions: [
                    {
                      all: 'all',
                      ids: [
                        
                      ]
                    }
                ],
                
                group_name: "",
                logoUrl: "",
                imgData: "",

                loading: false,

                header_color: "#f5f5f5",
                sub_header_color: "#ffffff",
                header_txt_color: "#000015",
                sub_header_txt_color: "#000015",
                sidebar_color: "#3c4b64",
                sidebar_txt_color: "white",
                sidebar_hover_color: "#321fdb",

                sidebar_mini_color: "#001533",
                sidebar_mini_hover_color: "#00004d",

                lang_list: [
                    { value: 'en', language: 'en', label: 'English' },
                    { value: 'es', language: 'es', label: 'Español' },
                    { value: 'it', language: 'en', label: 'Italian' },
                    { value: 'pt', language: 'en', label: 'Português' },
                    { value: 'fr', language: 'en', label: 'Française' },
                    { value: 'ru', language: 'en', label: 'Pусский' },
                    { value: 'de', language: 'en', label: 'Deutsche' }
                ],
                lang: 'en',

                group_id: null,


                table_loading: true,
                sub_items: [],
                
                showSorter: true,

                sub_fields: [
                  { key: 'group_name', label: 'Group name' },
                  { key: 'ids', label: 'Subscription IDs' },
                  { key: 'lang', label: 'Language' },
                  { key: 'logo_url', label: 'Logo', _style:'width:100px' },
                  { key: 'action', label: 'Action' },                 
                ],

                update_key: 0,

                color_options: [
                    {
                        label: "white",
                        value: "white"
                    },
                    {
                        label: "black",
                        value: "black"
                    },
                    {
                        label: "gray",
                        value: "gray"
                    },
                    {
                        label: "red",
                        value: "red"
                    },
                    {
                        label: "green",
                        value: "green"
                    },
                    {
                        label: "yellow",
                        value: "yellow"
                    },
                    {
                        label: "blue",
                        value: "blue"
                    },
                    {
                        label: "purple",
                        value: "purple"
                    },
                    {
                        label: "brown",
                        value: "brown"
                    },
                    {
                        label: "orange",
                        value: "orange"
                    },
                    {
                        label: "pink",
                        value: "pink"
                    },

                    {
                        label: "silver",
                        value: "silver"
                    },
                    {
                        label: "maroon",
                        value: "maroon"
                    },
                    {
                        label: "fuchsia",
                        value: "fuchsia"
                    },
                    {
                        label: "lime",
                        value: "lime"
                    },
                    {
                        label: "olive",
                        value: "olive"
                    },
                    {
                        label: "navy",
                        value: "navy"
                    },
                    {
                        label: "teal",
                        value: "teal"
                    },
                    {
                        label: "aqua",
                        value: "aqua"
                    },
                    {
                        label: "yellowgreen",
                        value: "yellowgreen"
                    },

                    {
                        label: "skyblue",
                        value: "skyblue"
                    },

                    {
                        label: "lightgray",
                        value: "lightgray"
                    },
                    {
                        label: "lightblue",
                        value: "lightblue"
                    },
                    {
                        label: "lightred",
                        value: "lightred"
                    },
                    {
                        label: "lightpurple",
                        value: "lightpurple"
                    },
                    {
                        label: "lightgreen",
                        value: "lightgreen"
                    },
                    {
                        label: "lightpink",
                        value: "lightpink"
                    },
                    {
                        label: "lightyellow",
                        value: "lightyellow"
                    },
                    {
                        label: "darkgray",
                        value: "darkgray"
                    },
                    {
                        label: "darkgreen",
                        value: "darkgreen"
                    },
                    {
                        label: "darkred",
                        value: "darkred"
                    },
                    {
                        label: "darkblue",
                        value: "darkblue"
                    },
                    {
                        label: "darkorange",
                        value: "darkorange"
                    } 
                ],
            }
        },
        computed: {
            ...mapGetters(['loggedInUser']),

            canPost() {
                
                if (this.sub_ids.length == 0 || this.group_name == "" || ( this.logoUrl == "" && this.imgData == "" ))
                    return false;
                else
                    return true;
            }

            // imageUrl() {
            //     let result = 'img/logo-sm.png';
                
            //     return result;
            // },
        },
        methods: {
            ...mapActions([
                'saveSubscriptionGroup',
                'getSubscriptionGroups',
                'updateSubscriptionGroup',
                'deleteSubscriptionGroup',
                'membership_ids'
            ]),
            cancel() {
                this.initParams();
            },
            initParams() {
                this.sub_ids = [];
                this.group_name = "";
                this.logoUrl = "";
                this.lang = "en";

                this.header_color = "#f5f5f5";
                this.sub_header_color = "#ffffff";
                this.header_txt_color = "#000015";
                this.sub_header_txt_color = "#000015";
                this.sidebar_color = "#3c4b64";
                this.sidebar_txt_color = "white";
                this.sidebar_hover_color = "#321fdb";

                this.sidebar_mini_color = "#001533";
                this.sidebar_mini_hover_color = "#00004d";

                this.group_id = null;
                this.membership_url = "https://sospesosoftwares.com/#pricing";

                this.tutorial_url = "";
                this.facebook = {
                    check: false,
                    url: ""
                };
                this.instagram = {
                    check: false,
                    url: ""
                };               
                this.whatsapp = {
                    check: false,
                    url: ""
                };                
                this.youtube = {
                    check: false,
                    url: ""
                };               
                this.telegram = {
                    check: false,
                    url: ""
                };
                this.feed_alert = true;
            },
            getEmptyGroup() {
                return {
                    
                    group_name : "",
                    logoUrl : "",
                    lang : "en",

                    header_color : "#f5f5f5",
                    sub_header_color :  "#ffffff",
                    header_txt_color :  "#000015",
                    sub_header_txt_color :  "#000015",
                    sidebar_color  : "#3c4b64",
                    sidebar_txt_color:"white",
                    sidebar_hover_color :  "#321fdb",

                    sidebar_mini_color :  "#001533",
                    sidebar_mini_hover_color :  "#00004d",

                    group_id :  null,
                    membership_url: "https://sospesosoftwares.com/#pricing",                    
                };
                
            },
            editGroup(_id) {
                let this_group = this.sub_items.filter( item => item._id == _id);
                this_group = this_group[0];

                this.group_id = _id;

                this.sub_ids = this_group.sub_ids;
                this.group_name = this_group.group_name;
                this.logoUrl = this_group.logo_url;
                this.lang = this_group.lang;

                this.header_color = this_group.header_color;
                this.sub_header_color = this_group.sub_header_color;
                this.header_txt_color = this_group.header_txt_color;
                this.sub_header_txt_color = this_group.sub_header_txt_color;
                this.sidebar_color = this_group.sidebar_color;
                this.sidebar_txt_color = this_group.sidebar_txt_color;
                this.sidebar_hover_color = this_group.sidebar_hover_color;

                this.sidebar_mini_color = this_group.sidebar_mini_color;
                this.sidebar_mini_hover_color = this_group.sidebar_mini_hover_color;

                this.openCreateGroup = true;
                if (this_group.membership_url)
                    this.membership_url = this_group.membership_url;
                else
                    this.membership_url = "https://sospesosoftwares.com/#pricing";

                if (this_group.tutorial_url)
                    this.tutorial_url = this_group.tutorial_url;
                else
                    this.tutorial_url = "";

                if (this_group.facebook)
                    this.facebook = this_group.facebook;
                else
                    this.facebook = {
                        check: false,
                        url: ""
                    };

                if (this_group.instagram)
                    this.instagram = this_group.instagram;
                else
                    this.instagram = {
                        check: false,
                        url: ""
                    };
                if (this_group.whatsapp)
                    this.whatsapp = this_group.whatsapp;
                else
                    this.whatsapp = {
                        check: false,
                        url: ""
                    };

                if (this_group.youtube)
                    this.youtube = this_group.youtube;
                else
                    this.youtube = {
                        check: false,
                        url: ""
                    };

                if (this_group.telegram)
                    this.telegram = this_group.telegram;
                else
                    this.telegram = {
                        check: false,
                        url: ""
                    };

                if (this_group.feed_alert === false)
                    this.feed_alert = false;
                else
                    this.feed_alert = true;


                window.scrollTo(0,0);
            },
            deleteGroup(_id) {
                let indexOfArrayItem = this.sub_items.findIndex( item => item._id == _id);
                swal
                    .fire({
                        title: "Are you sure?",
                        text: "You won't be able to revert this!",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Yes, delete it!",
                    })
                    .then((result) => {
                        if (result.value) {
                            this.deleteSubscriptionGroup({ _id: _id}).then((data) => {
                                this.sub_items.splice(indexOfArrayItem, 1);
                                
                            }).finally(() => {
                                
                            });
                            
                        }
                    });

            },
            copyGroup(_id) {
                let this_group = this.sub_items.filter( item => item._id == _id);
                this_group = this_group[0];

                this.sub_ids = this_group.sub_ids;
                this.group_name = "";
                
                this.lang = this_group.lang;

                this.header_color = this_group.header_color;
                this.sub_header_color = this_group.sub_header_color;
                this.header_txt_color = this_group.header_txt_color;
                this.sub_header_txt_color = this_group.sub_header_txt_color;
                this.sidebar_color = this_group.sidebar_color;
                this.sidebar_txt_color = this_group.sidebar_txt_color;
                this.sidebar_hover_color = this_group.sidebar_hover_color;

                this.sidebar_mini_color = this_group.sidebar_mini_color;
                this.sidebar_mini_hover_color = this_group.sidebar_mini_hover_color;
                if (this_group.membership_url)
                    this.membership_url = this_group.membership_url;

                if (this_group.tutorial_url)
                    this.tutorial_url = this_group.tutorial_url;
                else
                    this.tutorial_url = "";

                if (this_group.facebook)
                    this.facebook = this_group.facebook;
                else
                    this.facebook = {
                        check: false,
                        url: ""
                    };

                if (this_group.instagram)
                    this.instagram = this_group.instagram;
                else
                    this.instagram = {
                        check: false,
                        url: ""
                    };
                if (this_group.whatsapp)
                    this.whatsapp = this_group.whatsapp;
                else
                    this.whatsapp = {
                        check: false,
                        url: ""
                    };

                if (this_group.youtube)
                    this.youtube = this_group.youtube;
                else
                    this.youtube = {
                        check: false,
                        url: ""
                    };
                    
                if (this_group.telegram)
                    this.telegram = this_group.telegram;
                else
                    this.telegram = {
                        check: false,
                        url: ""
                    };

                if (this_group.feed_alert === false)
                    this.feed_alert = false;
                else
                    this.feed_alert = true;
                    


                this.openCreateGroup = true;
                window.scrollTo(0,0);

            },

            syncCreateGroup() {
                this.openCreateGroup = !this.openCreateGroup;
            },

            cropped(e) {
                console.log("============= hahahah   ")
                console.log("e", e)
                this.imgData = e;
            },
            saveLogo() {
                let post_data = {
                    group_name: this.group_name,
                    sub_ids: this.sub_ids,
                    lang: this.lang,
                    logoUrl: this.imgData,
                    header_color: this.header_color,
                    sub_header_color: this.sub_header_color,
                    header_txt_color: this.header_txt_color,
                    sub_header_txt_color: this.sub_header_txt_color,
                    sidebar_color: this.sidebar_color,
                    sidebar_txt_color: this.sidebar_txt_color,
                    sidebar_hover_color: this.sidebar_hover_color,

                    sidebar_mini_color: this.sidebar_mini_color,
                    sidebar_mini_hover_color: this.sidebar_mini_hover_color,
                    membership_url: this.membership_url,

                    tutorial_url: this.tutorial_url,
                    instagram: this.instagram,
                    facebook: this.facebook,
                    whatsapp: this.whatsapp,
                    youtube: this.youtube,
                    telegram: this.telegram,
                    feed_alert: this.feed_alert,
                };

                this.loading = true;
                this.saveSubscriptionGroup({ post_data: post_data}).then((data) => {
                    let group = data.data;
                    let sub_ids = group.sub_ids;
                    let ids = sub_ids.map(({ value }) => value);

                    let new_group = {
                        ...group,
                        ids: ids,
                        logo_url: `${VUE_APP_URL}/${group.logoUrl}`
                    };
                    this.sub_items.push(new_group);
                    
                }).finally(() => {
                    this.loading = false;
                    this.initParams();
                    this.openCreateGroup = false;
                });

            },
            updateLogo() {
                
                let post_data = {
                    group_name: this.group_name,
                    sub_ids: this.sub_ids,
                    lang: this.lang,
                    logoUrl: this.imgData,
                    header_color: this.header_color,
                    sub_header_color: this.sub_header_color,
                    header_txt_color: this.header_txt_color,
                    sub_header_txt_color: this.sub_header_txt_color,
                    sidebar_color: this.sidebar_color,
                    sidebar_txt_color: this.sidebar_txt_color,
                    sidebar_hover_color: this.sidebar_hover_color,

                    sidebar_mini_color: this.sidebar_mini_color,
                    sidebar_mini_hover_color: this.sidebar_mini_hover_color,
                    membership_url: this.membership_url,

                    tutorial_url: this.tutorial_url,
                    instagram: this.instagram,
                    facebook: this.facebook,
                    whatsapp: this.whatsapp,
                    youtube: this.youtube,
                    telegram: this.telegram,
                    feed_alert: this.feed_alert
                };

                this.loading = true;
                this.updateSubscriptionGroup({ post_data: post_data, _id: this.group_id}).then((data) => {
                    let new_group = data.data;
                    let g_index = this.sub_items.findIndex( item => item._id == this.group_id);
                    

                    let sub_ids = new_group.sub_ids;
                    let ids = sub_ids.map(({ value }) => value);

                    this.sub_items[g_index] = {
                        ...this.sub_items[g_index],
                        ...new_group,
                        ids: ids                       
                    };

                    if (new_group.logoUrl) {                        
                        this.sub_items[g_index].logo_url = `${VUE_APP_URL}/${new_group.logoUrl}?${Date.now()}`;
                    }

                    displaySuccess(data);

                    this.update_key += 1;
                    this.initParams();
                    this.openCreateGroup = false;


                    
                }).finally(() => {
                    this.loading = false;
                });

            },            
            cancel() {
                this.initParams();
                this.openCreateGroup = false;
            },

            get_all_subIDs() {
                
                this.membership_ids().then((data) => {
                    let subscr_list = [];
                    let items = data.data;
                    items.sort(function(a, b){return a-b});
                    for (let i=0; i<items.length; i++) {
                        let item = items[i]
                        subscr_list.push({'value': item, 'label': item})
                        
                    }
                    this.idOptions[0].ids = subscr_list;

                    
                }).finally(() => {
                    
                });

            },
            get_all_subscrList() {
                this.getSubscriptionGroups().then((data) => {
                    let sub_items = [];
                    let groups = data.data;
                    for (let i=0; i<groups.length; i++) {
                        let group = groups[i];
                        let sub_ids = group.sub_ids;
                        let ids = sub_ids.map(({ value }) => value);

                        let emptyGroup = this.getEmptyGroup();

                        let new_group = {
                            ...emptyGroup,
                            ...group,
                            ids: ids,
                            logo_url: `${VUE_APP_URL}/${group.logoUrl}`
                        };
                        sub_items.push(new_group);
                    }
                    this.sub_items = sub_items;

                    
                }).finally(() => {
                    this.table_loading = false;
                });

            }
        },
       
        mounted() {
            
        },
        created() {
            this.get_all_subIDs();
            this.get_all_subscrList();
            
        },
        beforeDestroy() {
            
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
    .card_background{
        padding: 10px;
        padding-top: 26px;
    }

    .card_background > .card-body{
        background-color: #f5f5f5;
        border-radius: 10px;
        border: 1px solid lightgray;
    }
    
    
    .table_pre_row {
        background: rgba(193, 176, 215, 0.75);
        border-left: 1px solid white;
        height: 30px;
        padding: 0px;
        min-width: 100px;
    }
    
    .table-header-stick {
        background: rgb(183, 234, 252);
        padding: 3px;
        position: sticky;
        top: 0;
        z-index: 1;
    }
    .bets-table {
        overflow-x: auto;
        overflow-y: auto;
    }
    .form-group {
        margin-bottom: 5px !important;
        padding-left: 5px !important;
        padding-right: 5px !important;
    }
    .dlg-setting-section {
        background-color: lavenderblush;
        margin-bottom: 15px;
    }
    .dlg-setting-section-title {
        color: blue;
        padding-top: 10px;
        padding-left: 10px;
    }
    .bet-row {
        border-bottom-color: white;
        border-bottom-style: ridge;
    }
    
</style>